// Module
var code = "<template><div class=\"dialog-login dialog-wrap\"><iframe class=\"iframe-login\" id=\"login\" src.two-way=\"page\"></iframe></div></template>";
// Exports
module.exports = code;